import React from 'react';
import { Avatar, theme } from 'antd';
import 'antd/dist/reset.css';

function UserBubble({ color, x = 0, y = 200 }) {
  const { token } = theme.useToken();
  const bubbleColor = color || token.colorSuccess; // fallback to AntD green

  return (
    <div style={{
      position: 'absolute',
      left: x,
      top: y,
      display: 'flex'
    }}>
      <div style={{
        position: 'relative',
        backgroundColor: bubbleColor,
        color: 'white',
        borderRadius: '20px',
        padding: '8px 12px 8px 8px',
        display: 'flex',
        alignItems: 'center',
        fontSize: '14px',
        fontWeight: 500
      }}>
        <Avatar
          src="https://randomuser.me/api/portraits/women/44.jpg" // Replace with your avatar
          alt="User"
          size={28}
          style={{ marginRight: 8 }}
        />
        John Doe Silva
        <div style={{
          position: 'absolute',
          bottom: '-8px',
          right: '8px',
          width: 0,
          height: 0,
          borderLeft: '12px solid transparent',
          borderRight: '12px solid transparent',
          borderTop: `12px solid ${bubbleColor}`,
          transform: 'rotate(-16deg)',
          zIndex: -1
        }} />
      </div>
    </div>
  );
}

export default UserBubble;
